import { useCallback } from 'react';

import { useToast } from '@/hooks/use-toast';
import { downloadJobFile } from './downloadJobFile';

/**
 * Download a job file, reporting a failure the same way wherever it is offered.
 *
 * Three places hand out a Download — the actions menu, the photo viewer and the
 * document viewer — and a download that quietly does nothing is the worst of the
 * failure modes. One hook so all three keep saying so.
 */
export function useJobFileDownload(jobId: string) {
  const { toast } = useToast();

  return useCallback(
    async (fileId: string) => {
      try {
        await downloadJobFile(jobId, fileId);
      } catch (error) {
        toast({
          title: 'Error',
          description: error instanceof Error ? error.message : 'Failed to download file.',
          variant: 'destructive',
        });
      }
    },
    [jobId, toast],
  );
}
